(() => {
  const app = document.getElementById('app');
  if (!app) return;
  const parseConfigScript = (node) => {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      console.warn('Theme editor configuration could not be read.', error);
      return null;
    }
  };
  const readSectionConfig = (name) => parseConfigScript(document.querySelector(`[data-alani-section="${name}"]`));
  const readHomeModuleConfig = (name) => parseConfigScript(document.querySelector(`[data-alani-home-module="${name}"]`));
  const readHomeModules = () => Array.from(document.querySelectorAll('[data-alani-home-module]')).map((node) => ({
    type: node.getAttribute('data-alani-home-module') || '',
    config: parseConfigScript(node) || {}
  })).filter((item) => item.type);
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
  const CART_KEY = 'alantrinu.preview.cart';
  const assetUrl = (value) => {
    if (!value || !String(value).startsWith('/assets/')) return value;
    const base = window.ALANI_ASSET_BASE || '/assets/';
    return `${base}${String(value).slice('/assets/'.length)}`;
  };

  const assets = {
    logo: '/assets/logo.png',
    heroDesktop: '/assets/hero-desktop.webp',
    heroMobile: '/assets/hero-mobile.webp',
    drinks: '/assets/category-drinks.webp',
    fitness: '/assets/category-fitness.webp',
    snacks: '/assets/category-snacks.webp',
    essentials: '/assets/category-essentials.webp',
    bestSellers: '/assets/promo-best-sellers.webp',
    bundles: '/assets/promo-bundles.webp',
    miniEnergyCherryTwist: '/assets/mini-energy-cherry-twist.webp',
    footerDesktop: '/assets/footer-desktop.webp',
    footerMobile: '/assets/footer-mobile.webp'
  };

  Object.keys(assets).forEach((key) => {
    assets[key] = assetUrl(assets[key]);
  });

  const collectionSources = {
    all: (product) => true,
    drinks: (product) => product.collection === 'energy',
    fitness: (product) => product.collection === 'new' || product.collection === 'accessories',
    snacks: (product) => product.collection === 'snacks',
    essentials: (product) => product.collection === 'accessories',
    'best-selling': (product) => product.tags.includes('featured') || product.collection === 'energy',
    bundles: (product) => product.collection === 'bundles',
    'save-on-favs': (product) => product.compareAt > product.price || product.tags.includes('featured')
  };

  const products = [
    {
      handle: 'mini-energy-cherry-twist-24-pack-q7',
      title: 'Mini Energy - Cherry Twist / 24 Pack Q7',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 9.00,
      compareAt: null,
      image: assets.miniEnergyCherryTwist,
      gallery: [assets.miniEnergyCherryTwist],
      blurb: 'Zero sugar, B vitamins, and 100mg of caffeine per serving.',
      description: 'Press rewind and refresh with Cherry Twist Mini Energy! A sweet mix of chill cherry and electric lime flavors, each can buzzes with zero sugar, B vitamins and just 100mg of caffeine per serving. Tiny? Totally - but just like leg warmers, they add a little neon kick to every move you make.',
      tags: ['featured', 'energy', 'mini']
    },
    {
      handle: 'pre-workout-burn-melonberry-blast-30-servings-i9',
      title: 'Pre-Workout Burn Melonberry Blast',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 29.99,
      compareAt: 34.99,
      image: assets.drinks,
      gallery: [assets.drinks, assets.bestSellers, assets.heroDesktop],
      blurb: 'A bright melon-forward pre-workout with clean energy and a bold finish.',
      description: 'A lively pre-workout blend designed for lift days, early starts, and everything in between.',
      tags: ['featured', 'best-sellers', 'energy']
    },
    {
      handle: 'pre-workout-burn-dragon-fruit-rush-30-servings-z4',
      title: 'Pre-Workout Burn Dragon Fruit Rush',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 29.99,
      compareAt: 34.99,
      image: assets.bestSellers,
      gallery: [assets.bestSellers, assets.drinks, assets.heroDesktop],
      blurb: 'Tart fruit punch energy with a crisp, refreshing finish.',
      description: 'For workouts that need a little extra spark without losing the flavor payoff.',
      tags: ['featured', 'energy']
    },
    {
      handle: 'pre-workout-juicy-peach-30-servings-u5',
      title: 'Pre-Workout Juicy Peach',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 28.99,
      compareAt: 33.99,
      image: assets.fitness,
      gallery: [assets.fitness, assets.heroDesktop, assets.bestSellers],
      blurb: 'Peachy, smooth, and built for an easy daily routine.',
      description: 'A softer profile with enough punch to keep the energy high and the mood light.',
      tags: ['featured', 'energy']
    },
    {
      handle: 'pre-workout-blue-slush-30-servings-w0',
      title: 'Pre-Workout Blue Slush',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 30.99,
      compareAt: 34.99,
      image: assets.snacks,
      gallery: [assets.snacks, assets.heroDesktop, assets.bestSellers],
      blurb: 'Cool, sweet, and loud in the best way.',
      description: 'A fan favorite for people who want the classic slush feel with a performance edge.',
      tags: ['featured', 'energy']
    },
    {
      handle: 'pre-workout-pink-slush-30-servings-q7',
      title: 'Pre-Workout Pink Slush',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 30.99,
      compareAt: 34.99,
      image: assets.essentials,
      gallery: [assets.essentials, assets.heroMobile, assets.bestSellers],
      blurb: 'Tart berry flavor with a creamy, icy finish.',
      description: 'A vibrant pink pick with the same reliable lift as the rest of the lineup.',
      tags: ['energy']
    },
    {
      handle: 'pre-workout-orange-kiss-30-servings-z6',
      title: 'Pre-Workout Orange Kiss',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 30.99,
      compareAt: 34.99,
      image: assets.bundles,
      gallery: [assets.bundles, assets.bestSellers, assets.heroDesktop],
      blurb: 'Citrus, sweet, and sunny.',
      description: 'Orange-flavored energy with a bright finish and a smooth mix profile.',
      tags: ['energy', 'new']
    },
    {
      handle: 'pre-workout-cherry-twist-30-servings-x2',
      title: 'Pre-Workout Cherry Twist',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 29.99,
      compareAt: 34.99,
      image: assets.drinks,
      gallery: [assets.drinks, assets.heroMobile, assets.bestSellers],
      blurb: 'Cherry candy flavor with a sharper edge.',
      description: 'Built to feel playful without losing the focused pre-workout feel.',
      tags: ['energy', 'new']
    },
    {
      handle: 'pre-workout-frozen-lemonade-30-servings-r0',
      title: 'Pre-Workout Frozen Lemonade',
      collection: 'energy',
      vendor: 'Alani Nu',
      price: 28.99,
      compareAt: 33.99,
      image: assets.bestSellers,
      gallery: [assets.bestSellers, assets.heroDesktop, assets.drinks],
      blurb: 'Sharp lemonade with a clean, cold finish.',
      description: 'A crisp option for people who prefer citrus over candy.',
      tags: ['energy']
    },
    {
      handle: 'alani-energy-bundle-8-pack',
      title: 'Alani Energy Bundle 8-Pack',
      collection: 'bundles',
      vendor: 'Alani Nu',
      price: 79.99,
      compareAt: 96.99,
      image: assets.bundles,
      gallery: [assets.bundles, assets.bestSellers],
      blurb: 'A mix-and-match starter bundle with your favorite flavors.',
      description: 'Build a cart-friendly bundle and save without thinking too hard.',
      tags: ['bundle', 'featured']
    },
    {
      handle: 'fan-favorite-starter-kit',
      title: 'Fan Favorite Starter Kit',
      collection: 'bundles',
      vendor: 'Alani Nu',
      price: 54.99,
      compareAt: 66.99,
      image: assets.bestSellers,
      gallery: [assets.bestSellers, assets.heroMobile],
      blurb: 'A small curated set for the first-time shopper.',
      description: 'A compact intro bundle built to help new customers pick a direction fast.',
      tags: ['bundle']
    },
    {
      handle: 'shaker-bottle',
      title: 'Shaker Bottle',
      collection: 'accessories',
      vendor: 'Alani Nu',
      price: 14.99,
      compareAt: 18.99,
      image: assets.essentials,
      gallery: [assets.essentials, assets.heroMobile],
      blurb: 'Simple shaker with a clean matte finish.',
      description: 'A no-fuss accessory for pre-workout days and everyday hydration.',
      tags: ['accessories']
    },
    {
      handle: 'logo-carry-tote',
      title: 'Logo Carry Tote',
      collection: 'accessories',
      vendor: 'Alani Nu',
      price: 24.99,
      compareAt: 29.99,
      image: assets.fitness,
      gallery: [assets.fitness, assets.bestSellers],
      blurb: 'A durable logo tote for store runs and gym days.',
      description: 'Big enough for the essentials and branded just enough to look right.',
      tags: ['accessories', 'new']
    },
    {
      handle: 'sample-pack-essentials',
      title: 'Sample Pack Essentials',
      collection: 'new',
      vendor: 'Alani Nu',
      price: 19.99,
      compareAt: 24.99,
      image: assets.snacks,
      gallery: [assets.snacks, assets.drinks, assets.bestSellers],
      blurb: 'A mixed sampler for a quick first order.',
      description: 'A small order that lets you try a few flavors without committing to the full shelf.',
      tags: ['new']
    },
    {
      handle: 'gift-card-t4',
      title: 'Gift Card',
      collection: 'gift-card',
      vendor: 'Alani Nu',
      price: 25,
      compareAt: null,
      image: assets.heroDesktop,
      gallery: [assets.heroDesktop, assets.bestSellers],
      blurb: 'A flexible gift for any Alani Nu fan.',
      description: 'A simple gift card preview so the menu link lands on a real product page.',
      tags: ['gift-card']
    }
  ];

  const originalProductData = {
    'mini-energy-cherry-twist-24-pack-q7': {
      title: 'Mini Energy - Cherry Twist / 24 Pack Q7',
      price: 9.00,
      compareAt: null,
      image: '/assets/mini-energy-cherry-twist-24-pack-q7.webp',
      gallery: ['/assets/mini-energy-cherry-twist-24-pack-q7-gallery-1.webp', '/assets/mini-energy-cherry-twist-24-pack-q7-gallery-2.webp', '/assets/mini-energy-cherry-twist-24-pack-q7-gallery-3.webp', '/assets/mini-energy-cherry-twist-24-pack-q7-gallery-4.webp', '/assets/mini-energy-cherry-twist-24-pack-q7-gallery-5.webp'],
      description: 'Cherry Twist Mini Energy pairs a bright cherry-lime taste with zero sugar, B vitamins, and 100mg of caffeine per serving. The smaller cans are easy to chill, pack, and enjoy whenever your day needs a lively lift.'
    },
    'pre-workout-burn-melonberry-blast-30-servings-i9': {
      title: 'Pre-Workout+ Burn - Melonberry Blast / 30 Servings I9',
      price: 9.90,
      compareAt: 49.99,
      image: '/assets/pre-workout-burn-melonberry-blast-30-servings-i9.webp',
      gallery: ['/assets/pre-workout-burn-melonberry-blast-30-servings-i9-gallery-1.webp', '/assets/pre-workout-burn-melonberry-blast-30-servings-i9-gallery-2.webp', '/assets/pre-workout-burn-melonberry-blast-30-servings-i9-gallery-3.webp', '/assets/pre-workout-burn-melonberry-blast-30-servings-i9-gallery-4.webp'],
      description: 'Melonberry Blast Pre-Workout+ Burn brings a juicy berry flavor to a focused workout routine. The formula combines amino acids with 200mg of caffeine per serving for a bold, energized start before training.*'
    },
    'pre-workout-burn-dragon-fruit-rush-30-servings-z4': {
      title: 'Pre-Workout+ Burn - Dragon Fruit Rush / 30 Servings Z4',
      price: 9.00,
      compareAt: 49.99,
      image: '/assets/pre-workout-burn-dragon-fruit-rush-30-servings-z4.webp',
      gallery: ['/assets/pre-workout-burn-dragon-fruit-rush-30-servings-z4-gallery-1.webp', '/assets/pre-workout-burn-dragon-fruit-rush-30-servings-z4-gallery-2.webp', '/assets/pre-workout-burn-dragon-fruit-rush-30-servings-z4-gallery-3.webp', '/assets/pre-workout-burn-dragon-fruit-rush-30-servings-z4-gallery-4.webp'],
      description: 'Dragon Fruit Rush Pre-Workout+ Burn adds a bright tropical note to your pre-workout ritual. Each serving delivers amino acids and 200mg of caffeine in a lively blend made for energized training days.*'
    },
    'pre-workout-juicy-peach-30-servings-u5': {
      title: 'Pre-Workout - Juicy Peach / 30 Servings U5',
      price: 7.90,
      compareAt: 49.99,
      image: '/assets/pre-workout-juicy-peach-30-servings-u5.webp',
      gallery: ['/assets/pre-workout-juicy-peach-30-servings-u5-gallery-1.webp', '/assets/pre-workout-juicy-peach-30-servings-u5-gallery-2.webp', '/assets/pre-workout-juicy-peach-30-servings-u5-gallery-3.webp', '/assets/pre-workout-juicy-peach-30-servings-u5-gallery-4.webp', '/assets/pre-workout-juicy-peach-30-servings-u5-gallery-5.webp', '/assets/pre-workout-juicy-peach-30-servings-u5-gallery-6.webp'],
      description: 'Juicy Peach Pre-Workout blends a smooth peach flavor with 200mg of caffeine and 200mg of L-theanine per serving. It is an easy everyday pick for focused sessions, steady energy, and a fresh finish after your last set.*'
    },
    'pre-workout-blue-slush-30-servings-w0': {
      title: 'Pre-Workout+ - Blue Slush / 30 Servings W0',
      price: 8.00,
      compareAt: 49.99,
      image: '/assets/pre-workout-blue-slush-30-servings-w0.webp',
      gallery: ['/assets/pre-workout-blue-slush-30-servings-w0-gallery-1.webp', '/assets/pre-workout-blue-slush-30-servings-w0-gallery-2.webp', '/assets/pre-workout-blue-slush-30-servings-w0-gallery-3.webp', '/assets/pre-workout-blue-slush-30-servings-w0-gallery-4.webp', '/assets/pre-workout-blue-slush-30-servings-w0-gallery-5.webp'],
      description: 'Blue Slush Pre-Workout+ delivers a cool, candy-like flavor with 300mg of caffeine and 200mg of L-theanine per serving. Built for high-energy sessions, it also supports a focused routine with added hydration support.*'
    },
    'pre-workout-pink-slush-30-servings-q7': {
      title: 'Pre-Workout - Pink Slush / 30 Servings Q7',
      price: 7.98,
      compareAt: 49.99,
      image: '/assets/pre-workout-pink-slush-30-servings-q7.webp',
      gallery: ['/assets/pre-workout-pink-slush-30-servings-q7-gallery-1.webp', '/assets/pre-workout-pink-slush-30-servings-q7-gallery-2.webp', '/assets/pre-workout-pink-slush-30-servings-q7-gallery-3.webp', '/assets/pre-workout-pink-slush-30-servings-q7-gallery-4.webp', '/assets/pre-workout-pink-slush-30-servings-q7-gallery-5.webp'],
      description: 'Pink Slush Pre-Workout turns a bright berry flavor into a simple daily training ritual. Each serving includes 200mg of caffeine and 200mg of L-theanine to help you begin with energy and stay locked in through your workout.*'
    },
    'pre-workout-orange-kiss-30-servings-z6': {
      title: 'Pre-Workout - Orange Kiss / 30 Servings Z6',
      price: 7.96,
      compareAt: 49.99,
      image: '/assets/pre-workout-orange-kiss-30-servings-z6.webp',
      gallery: ['/assets/pre-workout-orange-kiss-30-servings-z6-gallery-1.webp', '/assets/pre-workout-orange-kiss-30-servings-z6-gallery-2.webp', '/assets/pre-workout-orange-kiss-30-servings-z6-gallery-3.webp', '/assets/pre-workout-orange-kiss-30-servings-z6-gallery-4.webp'],
      description: 'Orange Kiss Pre-Workout has a sunny citrus profile with 200mg of caffeine and 200mg of L-theanine per serving. It is made for a smooth, focused start when you want a little more drive in your training routine.*'
    },
    'pre-workout-cherry-twist-30-servings-x2': {
      title: 'Pre-Workout - Cherry Twist / 30 Servings X2',
      price: 7.90,
      compareAt: 49.99,
      image: '/assets/pre-workout-cherry-twist-30-servings-x2.webp',
      gallery: ['/assets/pre-workout-cherry-twist-30-servings-x2-gallery-1.webp', '/assets/pre-workout-cherry-twist-30-servings-x2-gallery-2.webp', '/assets/pre-workout-cherry-twist-30-servings-x2-gallery-3.webp', '/assets/pre-workout-cherry-twist-30-servings-x2-gallery-4.webp', '/assets/pre-workout-cherry-twist-30-servings-x2-gallery-5.webp'],
      description: 'Cherry Twist Pre-Workout brings a crisp cherry-candy flavor to your next session. With 200mg of caffeine and 200mg of L-theanine per serving, it is a bright, focused option for repeat training days.*'
    },
    'pre-workout-frozen-lemonade-30-servings-r0': {
      title: 'Pre-Workout+ - Frozen Lemonade / 30 Servings R0',
      price: 8.98,
      compareAt: 49.99,
      image: '/assets/pre-workout-frozen-lemonade-30-servings-r0.webp',
      gallery: ['/assets/pre-workout-frozen-lemonade-30-servings-r0-gallery-1.webp', '/assets/pre-workout-frozen-lemonade-30-servings-r0-gallery-2.webp', '/assets/pre-workout-frozen-lemonade-30-servings-r0-gallery-3.webp', '/assets/pre-workout-frozen-lemonade-30-servings-r0-gallery-4.webp'],
      description: 'Frozen Lemonade Pre-Workout+ combines a sharp citrus taste with 300mg of caffeine and 200mg of L-theanine per serving. The refreshing blend is designed for energized sessions, focused work, and a clean lemonade finish.*'
    },
    'gift-card-t4': {
      title: 'Gift Card T4',
      price: 2.98,
      compareAt: null,
      image: '/assets/gift-card-t4.webp',
      gallery: ['/assets/gift-card-t4-gallery-1.webp'],
      description: 'Give an Alani Nu fan the freedom to choose their favorite flavors with a flexible digital gift card. It is an easy option for birthdays, thank-yous, celebrations, or a little treat just because.'
    }
  };

  const originProductData = window.ALANI_ORIGIN_PRODUCT_DATA || {};
  Object.entries(originProductData).forEach(([handle, origin]) => {
    if (originalProductData[handle]) {
      Object.assign(originalProductData[handle], origin);
    }
  });

  products.forEach((product) => {
    const original = originalProductData[product.handle];
    if (!original) return;
    Object.assign(product, original, {
      gallery: original.gallery || [original.image],
      blurb: ''
    });
  });

  products.forEach((product) => {
    product.image = assetUrl(product.image);
    product.gallery = (product.gallery || []).map(assetUrl);
  });

  const collections = {
    all: {
      title: 'Products',
      eyebrow: 'Collection',
      description: 'Shop the full catalog of fan favorites, bundles, and accessories.',
      image: assets.heroDesktop
    },
    drinks: {
      title: 'Drinks',
      eyebrow: 'Collection',
      description: 'Energy drinks and pre-workout picks for busy days and hard sessions.',
      image: assets.drinks
    },
    fitness: {
      title: 'Fitness',
      eyebrow: 'Collection',
      description: 'Workout support and wellness staples for the daily routine.',
      image: assets.fitness
    },
    snacks: {
      title: 'Snacks',
      eyebrow: 'Collection',
      description: 'Grab-and-go picks with the same bright flavor language.',
      image: assets.snacks
    },
    essentials: {
      title: 'Essentials',
      eyebrow: 'Collection',
      description: 'Useful extras for your desk, gym bag, and kitchen shelf.',
      image: assets.essentials
    },
    'best-selling': {
      title: 'Best Sellers',
      eyebrow: 'Collection',
      description: 'The flavors people keep coming back for.',
      image: assets.bestSellers
    },
    bundles: {
      title: 'Bundle & Save',
      eyebrow: 'Collection',
      description: 'Curated sets that make it easy to stack favorites and save.',
      image: assets.bundles
    },
    'save-on-favs': {
      title: 'Save on favs',
      eyebrow: 'Collection',
      description: 'A curated sale collection for your current favorites.',
      image: assets.bestSellers
    }
  };

  const pages = {
    about: {
      title: 'About',
      eyebrow: 'Page',
      body: '<p>Alani Nu is a bright, flavor-first wellness brand built around easy daily rituals and louder-than-average taste.</p><p>This preview mimics the structure and feel of the original storefront so you can click through collections, products, search, and cart flows locally.</p>'
    },
    'about-us': {
      title: 'About Us',
      eyebrow: 'Page',
      body: '<p>Learn more about our store, our approach to customer service, and the shopping experience we provide.</p>'
    },
    contact: {
      title: 'Contact',
      eyebrow: 'Page',
      body: '<p>Reach out through the form below or use the support links in the footer.</p>'
    },
    'contact-information': {
      title: 'Contact Us',
      eyebrow: 'Policy',
      body: '<p>Use the contact details published by the store for order support, product questions, and policy enquiries.</p>'
    },
    faq: {
      title: 'FAQ',
      eyebrow: 'Page',
      body: '<p>Questions about ordering, shipping, or bundles can live here in the same structure as the original store.</p>'
    },
    'shipping-policy': {
      title: 'Shipping Policy',
      eyebrow: 'Policy',
      body: '<p>Orders ship from the preview store with mock delivery messaging and no payment capture.</p>'
    },
    'refund-policy': {
      title: 'Refund Policy',
      eyebrow: 'Policy',
      body: '<p>Refunds are shown as store-policy content only in this local preview.</p>'
    },
    'payment-policy': {
      title: 'Payment Policy',
      eyebrow: 'Policy',
      body: '<p>Available payment methods and checkout terms are explained on this page.</p>'
    },
    'privacy-policy': {
      title: 'Privacy Policy',
      eyebrow: 'Policy',
      body: '<p>This is a local preview environment and does not transmit customer data externally.</p>'
    },
    'terms-of-service': {
      title: 'Terms of Service',
      eyebrow: 'Policy',
      body: '<p>Standard preview-only terms placeholder for the storefront shell.</p>'
    }
  };

  const articles = [
    {
      handle: 'summer-sips',
      title: 'Summer Sips Worth Keeping Cold',
      image: assets.heroDesktop,
      publishedAt: '2026-08-05',
      excerpt: 'A quick look at the brightest flavors in the current lineup and how to build a simple bundle around them.',
      content: '<p>Start with a citrus flavor, add one candy-leaning option, and finish with something cool enough to keep in rotation.</p><p>This preview article exists so blog links feel like real storefront navigation instead of dead ends.</p>'
    },
    {
      handle: 'bundle-guide',
      title: 'How to Build a Better Starter Bundle',
      image: assets.bundles,
      publishedAt: '2026-07-22',
      excerpt: 'Mix a core flavor, a seasonal pick, and one wild card. That is usually enough.',
      content: '<p>A good bundle should feel like a shortcut, not homework.</p>'
    }
  ];

  const menu = [
    {
      label: 'Shop',
      href: '/collections/drinks',
      children: [
        { label: 'Drinks', href: '/collections/drinks' },
        { label: 'Fitness', href: '/collections/fitness' },
        { label: 'Snacks', href: '/collections/snacks' },
        { label: 'Essentials', href: '/collections/essentials' },
        { label: 'Gift Card', href: '/products/gift-card-t4' }
      ]
    },
    { label: 'Best Sellers', href: '/collections/best-selling' },
    { label: 'Bundles', href: '/collections/bundles' },
    { label: 'Save on favs', href: '/collections/save-on-favs' }
  ];

  const footerMenus = [
    { heading: 'Customer Service', items: [
      { label: 'Shipping Policy', href: '/policies/shipping-policy' },
      { label: 'Refund Policy', href: '/policies/refund-policy' },
      { label: 'FAQ', href: '/pages/faq' },
      { label: 'Contact Us', href: '/policies/contact-information' }
    ] },
    { heading: 'Company & Policies', items: [
      { label: 'About Us', href: '/pages/about-us' },
      { label: 'Payment Policy', href: '/pages/payment-policy' },
      { label: 'Privacy Policy', href: '/policies/privacy-policy' },
      { label: 'Terms of Service', href: '/policies/terms-of-service' }
    ] }
  ];

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(value) {
    return money.format(value);
  }

  function slugFromTitle(text) {
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function productUrl(product) {
    return `/products/${product.handle}`;
  }

  function collectionUrl(handle) {
    return `/collections/${handle}`;
  }

  function getCart() {
    try {
      const raw = localStorage.getItem(CART_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  function setCart(cart) {
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    updateCartBadge();
  }

  function cartCount() {
    return getCart().reduce((sum, item) => sum + item.quantity, 0);
  }

  function normalizeProduct(product) {
    const gallery = Array.isArray(product.gallery) ? product.gallery.filter(Boolean).map(assetUrl) : [];
    const image = assetUrl(product.image || gallery[0] || '');
    return {
      ...product,
      handle: String(product.handle || ''),
      title: String(product.title || ''),
      vendor: String(product.vendor || 'Alani Nu'),
      price: Number(product.price || 0),
      compareAt: Number(product.compareAt || 0) || null,
      image,
      gallery: gallery.length ? gallery : (image ? [image] : []),
      collection: String(product.collection || 'all'),
      description: String(product.description || ''),
      tags: Array.isArray(product.tags) ? product.tags : [],
      variants: Array.isArray(product.variants) ? product.variants : []
    };
  }

  function getCatalogProducts() {
    const merged = products.map((product) => normalizeProduct(product));
    const featuredConfig = readHomeModuleConfig('featured');
    const editableProducts = Array.isArray(featuredConfig?.products) ? featuredConfig.products.map(normalizeProduct) : [];
    const collectionConfig = readSectionConfig('main-collection');
    const collectionProducts = Array.isArray(collectionConfig?.products) ? collectionConfig.products.map(normalizeProduct) : [];
    const productConfig = readSectionConfig('main-product');
    const currentProduct = productConfig?.product ? [normalizeProduct(productConfig.product)] : [];
    [...collectionProducts, ...editableProducts, ...currentProduct].forEach((product) => {
      if (!product.handle) return;
      const index = merged.findIndex((item) => item.handle === product.handle);
      if (index >= 0) merged[index] = product;
      else merged.push(product);
    });
    return merged;
  }

  function findProduct(handle) {
    return getCatalogProducts().find((product) => product.handle === handle);
  }

  function getCollection(handle) {
    const catalogProducts = getCatalogProducts();
    const collectionConfig = readSectionConfig('main-collection');
    if (collectionConfig && String(collectionConfig.handle || '') === handle) {
      return {
        handle,
        title: String(collectionConfig.title || collections[handle]?.title || handle),
        eyebrow: String(collectionConfig.eyebrow || 'Collection'),
        description: String(collectionConfig.description || ''),
        image: collections[handle]?.image || assets.heroDesktop,
        products: Array.isArray(collectionConfig.products) ? collectionConfig.products.map(normalizeProduct) : [],
        productsCount: Number(collectionConfig.productsCount || 0),
        pagination: collectionConfig.pagination || null,
        isLiveCollection: true
      };
    }
    if (handle === 'all') {
      return {
        ...collections.all,
        handle: 'all',
        products: catalogProducts
      };
    }

    const meta = collections[handle];
    if (!meta) return null;
    const predicate = collectionSources[handle];
    return {
      ...meta,
      handle,
      products: predicate ? catalogProducts.filter(predicate) : []
    };
  }

  function getArticle(handle) {
    return articles.find((article) => article.handle === handle);
  }

  function getPage(handle) {
    return pages[handle];
  }

  function sortProducts(items, sortBy) {
    const list = [...items];
    switch (sortBy) {
      case 'title-ascending':
        return list.sort((a, b) => a.title.localeCompare(b.title));
      case 'price-ascending':
        return list.sort((a, b) => a.price - b.price);
      case 'price-descending':
        return list.sort((a, b) => b.price - a.price);
      case 'best-selling':
        return list.sort((a, b) => {
          const aScore = a.tags.includes('featured') ? 1 : 0;
          const bScore = b.tags.includes('featured') ? 1 : 0;
          return bScore - aScore || a.title.localeCompare(b.title);
        });
      default:
        return list;
    }
  }

  function toQueryString(params) {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value != null && value !== '') query.set(key, value);
    });
    const out = query.toString();
    return out ? `?${out}` : '';
  }

  function routeInfo() {
    const url = new URL(location.href);
    const path = url.pathname.replace(/\/+$/, '') || '/';
    const segments = path.split('/').filter(Boolean);
    return { url, path, segments };
  }

  function navigate(url) {
    const next = new URL(url, location.origin);
    const themeConfig = readSectionConfig('theme-settings');
    if (themeConfig?.shopify === true) {
      const current = new URL(location.href);
      ['preview_theme_id', 'preview_key', 'view'].forEach((key) => {
        if (current.searchParams.has(key) && !next.searchParams.has(key)) {
          next.searchParams.set(key, current.searchParams.get(key));
        }
      });
      location.assign(`${next.pathname}${next.search}${next.hash}`);
      return;
    }
    history.pushState({}, '', `${next.pathname}${next.search}${next.hash}`);
    render();
  }

  function updateCartBadge() {
    const badge = app.querySelector('[data-cart-count]');
    if (!badge) return;
    const themeConfig = readSectionConfig('theme-settings');
    const count = themeConfig?.shopify === true ? Number(themeConfig.cartCount || 0) : cartCount();
    badge.textContent = count > 0 ? String(count) : '';
    badge.hidden = count === 0;
  }

  function renderHeader(currentPath) {
    const announcementConfig = readSectionConfig('announcement-bar');
    const headerConfig = readSectionConfig('site-header');
    const themeConfig = readSectionConfig('theme-settings');
    const configuredMenu = Array.isArray(headerConfig?.items)
      ? headerConfig.items.filter((item) => item && item.label).map((item) => ({
        label: String(item.label),
        href: item.href || '#',
        children: Array.isArray(item.children) ? item.children.filter((child) => child && child.label).map((child) => ({ label: String(child.label), href: child.href || '#' })) : []
      }))
      : [];
    const activeMenu = configuredMenu.length ? configuredMenu : menu;
    const logo = headerConfig?.logo || assets.logo;
    const logoAlt = headerConfig?.logoAlt || themeConfig?.brandName || 'TrendVibe Merch LLC';
    const inThemeEditor = themeConfig?.designMode === true || new URL(location.href).searchParams.has('preview_theme_id');
    const accountUrl = inThemeEditor ? '/' : (themeConfig?.accountUrl || (themeConfig?.shopify === true ? '/' : '/account'));
    const accountDisabled = themeConfig?.shopify === true && themeConfig?.customerAccountsEnabled !== true;
    const accountIsExternal = (() => {
      try { return new URL(accountUrl, location.origin).origin !== location.origin; } catch (error) { return false; }
    })();
    const accountTarget = accountIsExternal ? ' target="_blank" rel="noopener"' : '';
    const announcementText = announcementConfig ? String(announcementConfig.text || '') : 'Free shipping on all U.S. orders.';
    const announcementLink = announcementConfig?.link || '';
    const announcementMarkup = announcementText ? `
      <div class="announcement-bar">
        <div class="page-width announcement-bar__inner">
          ${announcementLink ? `<a class="announcement-bar__link" href="${escapeHtml(announcementLink)}">${escapeHtml(announcementText)}</a>` : `<p class="announcement-bar__text">${escapeHtml(announcementText)}</p>`}
        </div>
      </div>
    ` : '';
    const activeCollection = currentPath.startsWith('/collections/');
    const activeSearch = currentPath.startsWith('/search');
    const activeCart = currentPath.startsWith('/cart');
    const mobileLinks = activeMenu.map((item) => {
      const primary = item.children.length
        ? `<a href="${item.href}">${escapeHtml(item.label)}</a>`
        : `<a href="${item.href}">${escapeHtml(item.label)}</a>`;
      const children = item.children.length ? item.children.map((child) => `<a class="site-header__mobile-child" href="${escapeHtml(child.href)}">• ${escapeHtml(child.label)}</a>`).join('') : '';
      return primary + children;
    }).join('');

    return `
      ${announcementMarkup}
      <header class="site-header">
        <div class="page-width site-header__inner">
          <a class="site-header__logo" href="/" aria-label="${escapeHtml(logoAlt)}">
            <img src="${escapeHtml(logo)}" alt="${escapeHtml(logoAlt)}" loading="eager" decoding="async">
          </a>
          <nav class="site-header__nav site-header__nav--desktop" aria-label="Primary">
            ${activeMenu.map((item) => item.children.length ? `
              <details class="site-header__dropdown${currentPath.startsWith(item.href) ? ' is-active' : ''}" ${currentPath.startsWith(item.href) ? 'open' : ''}>
                <summary>${escapeHtml(item.label)} <span class="site-header__caret" aria-hidden="true">⌄</span></summary>
                <div class="site-header__dropdown-panel" role="menu">
                  ${item.children.map((child) => `<a href="${escapeHtml(child.href)}" role="menuitem">${escapeHtml(child.label)}</a>`).join('')}
                </div>
              </details>
            ` : `<a href="${escapeHtml(item.href)}"${currentPath.startsWith(item.href) ? ' aria-current="page"' : ''}>${escapeHtml(item.label)}</a>`).join('')}
          </nav>
          <div class="site-header__tools">
            <a href="/search" aria-label="Search"${activeSearch ? ' aria-current="page"' : ''}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="11" cy="11" r="6.5"></circle>
                <path d="M16.2 16.2 21 21"></path>
              </svg>
            </a>
            <a href="${escapeHtml(accountUrl)}" aria-label="Account"${accountTarget}${accountDisabled ? ' data-account-disabled="true" title="Customer accounts are not enabled"' : ''}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="8" r="3.4"></circle>
                <path d="M5.5 20c1.8-3.7 4.1-5.4 6.5-5.4S16.7 16.3 18.5 20"></path>
              </svg>
            </a>
            <a class="site-header__cart-link" href="/cart" aria-label="Cart"${activeCart ? ' aria-current="page"' : ''}>
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 6h16l-1.8 8.3a2 2 0 0 1-2 1.6H8.2a2 2 0 0 1-2-1.6L4.5 4.5H2"></path>
                <circle cx="9" cy="20" r="1.2"></circle>
                <circle cx="17" cy="20" r="1.2"></circle>
              </svg>
              <span class="site-header__cart-count" data-cart-count hidden></span>
            </a>
          </div>
        </div>
        <div id="MobileMenu" class="site-header__mobile" hidden>
          <div class="page-width site-header__mobile-inner" aria-label="Primary mobile">
            ${mobileLinks}
            <a href="/search">Search</a>
            <a href="${escapeHtml(accountUrl)}"${accountTarget}${accountDisabled ? ' data-account-disabled="true" title="Customer accounts are not enabled"' : ''}>Log in</a>
          </div>
        </div>
      </header>
    `;
  }

  function renderFooter() {
    const footerConfig = readSectionConfig('site-footer');
    const themeConfig = readSectionConfig('theme-settings');
    const configuredMenus = Array.isArray(footerConfig?.menus)
      ? footerConfig.menus.map((group) => ({
        heading: String(group.heading || ''),
        items: Array.isArray(group.items) ? group.items.filter((item) => item && item.label).map((item) => ({ label: String(item.label), href: item.href || '#' })) : []
      })).filter((group) => group.heading || group.items.length)
      : [];
    const activeFooterMenus = configuredMenus.some((group) => group.items.length) ? configuredMenus : footerMenus;
    const footerDesktop = footerConfig?.desktopBackground || assets.footerDesktop;
    const footerMobile = footerConfig?.mobileBackground || assets.footerMobile;
    const footerLogo = footerConfig?.logo || assets.logo;
    const paymentStrip = footerConfig?.paymentStrip || assetUrl('/assets/payment-icons-strip.png');
    const newsletterHeading = footerConfig?.newsletterHeading || 'Join our email list';
    const newsletterText = footerConfig?.newsletterText || 'Get exclusive deals and early access to new products.';
    const emailPlaceholder = footerConfig?.emailPlaceholder || 'Email';
    const subscribeLabel = footerConfig?.subscribeLabel || 'Subscribe';
    const copyrightName = footerConfig?.copyrightName || themeConfig?.brandName || 'TrendVibe Merch LLC';
    const copyrightText = footerConfig?.copyrightText || 'All rights reserved.';
    return `
      <footer class="site-footer">
        <div class="site-footer__top">
          <picture class="site-footer__bg" aria-hidden="true">
            <source media="(max-width: 749px)" srcset="${escapeHtml(footerMobile)}">
            <img src="${escapeHtml(footerDesktop)}" alt="" loading="lazy" decoding="async">
          </picture>
          <div class="page-width site-footer__content">
            <div class="site-footer__newsletter">
              <h2>${escapeHtml(newsletterHeading)}</h2>
              <p>${escapeHtml(newsletterText)}</p>
              <form class="site-footer__form" data-newsletter-form>
                <div class="site-footer__field">
                  <input type="email" placeholder="${escapeHtml(emailPlaceholder)}" aria-label="${escapeHtml(emailPlaceholder)}" required>
                  <button class="site-footer__submit" type="submit" aria-label="${escapeHtml(subscribeLabel)}">
                    <svg viewBox="0 0 14 10" aria-hidden="true">
                      <path d="M1 5h11.5"></path>
                      <path d="M7 1l5.5 4-5.5 4"></path>
                    </svg>
                  </button>
                </div>
              </form>
            </div>
            ${activeFooterMenus.map((menuGroup) => `
              <nav class="site-footer__column" aria-label="${escapeHtml(menuGroup.heading)}">
                <h2>${escapeHtml(menuGroup.heading)}</h2>
                <ul class="site-footer__list">
                  ${menuGroup.items.map((item) => `<li><a href="${escapeHtml(item.href)}">${escapeHtml(item.label)}</a></li>`).join('')}
                </ul>
              </nav>
            `).join('')}
            <div class="site-footer__logo" aria-label="Logo">
              <a href="/" class="site-footer__logo-link">
                <img src="${escapeHtml(footerLogo)}" alt="${escapeHtml(copyrightName)}" loading="lazy" decoding="async">
              </a>
            </div>
          </div>
        </div>
        <div class="site-footer__bottom">
          <div class="page-width site-footer__bottom-inner">
            <small>&copy; ${new Date().getFullYear()} ${escapeHtml(copyrightName)}. ${escapeHtml(copyrightText)}</small>
            <img class="site-footer__payments-strip" src="${escapeHtml(paymentStrip)}" alt="Payment methods" loading="lazy" decoding="async" width="460" height="34">
          </div>
        </div>
      </footer>
    `;
  }

  function renderProductCard(product) {
    const hoverImage = product.gallery && product.gallery.length > 1 ? product.gallery[1] : '';
    return `
      <a class="product-card" href="${productUrl(product)}" data-nav>
        <div class="product-card__media">
          <img src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy" decoding="async">
          ${hoverImage ? `<img class="product-card__hover-image" src="${hoverImage}" alt="" loading="lazy" decoding="async">` : ''}
          ${product.compareAt > product.price ? '<span class="product-card__badge">Sale</span>' : ''}
        </div>
        <div class="product-card__content">
          <p class="product-card__vendor">${escapeHtml(product.vendor)}</p>
          <h3 class="product-card__title">${escapeHtml(product.title)}</h3>
          <div class="product-card__price">
            ${product.compareAt > product.price ? `<s>${formatMoney(product.compareAt)}</s> <span class="product-card__price--sale">${formatMoney(product.price)}</span>` : `<span>${formatMoney(product.price)}</span>`}
          </div>
        </div>
      </a>
    `;
  }

  function renderCollectionCard(collection) {
    return `
      <a class="collection-card" href="${collectionUrl(collection.handle)}" data-nav>
        <div class="collection-card__media">
          <img src="${collection.image}" alt="${escapeHtml(collection.title)}" loading="lazy" decoding="async">
        </div>
        <div class="collection-card__content">
          <h3 class="collection-card__title">${escapeHtml(collection.title)}</h3>
          <p class="collection-card__count">${collection.products.length} products</p>
        </div>
      </a>
    `;
  }

  function renderArticleCard(article) {
    return `
      <a class="article-card" href="/blogs/news/${article.handle}" data-nav>
        <div class="article-card__media">
          <img src="${article.image}" alt="${escapeHtml(article.title)}" loading="lazy" decoding="async">
        </div>
        <div class="article-card__content">
          <p class="article-card__meta">${new Date(article.publishedAt).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' })}</p>
          <h3 class="article-card__title">${escapeHtml(article.title)}</h3>
          <p class="article-card__excerpt">${escapeHtml(article.excerpt)}</p>
        </div>
      </a>
    `;
  }

  function renderHomeHero(config = {}) {
    const desktopImage = config.desktopImage || assets.heroDesktop;
    const mobileImage = config.mobileImage || assets.heroMobile;
    const imageAlt = config.alt || 'Alani Nu celebration sale hero';
    const buttonOneLabel = config.buttonOneLabel || 'Shop mini';
    const buttonOneLink = config.buttonOneLink || '/products/mini-energy-cherry-twist-24-pack-q7';
    const buttonOneAria = config.buttonOneAria || 'Shop mini energy Cherry Twist';
    const buttonTwoLabel = config.buttonTwoLabel || 'Shop faves';
    const buttonTwoLink = config.buttonTwoLink || '/collections/save-on-favs';
    const buttonTwoAria = config.buttonTwoAria || 'Shop save on favs';
    return `
      <div class="homepage-showcase__hero">
        <picture>
          <source media="(max-width: 749px)" srcset="${escapeHtml(mobileImage)}">
          <img src="${escapeHtml(desktopImage)}" alt="${escapeHtml(imageAlt)}" loading="eager" fetchpriority="high" decoding="async">
        </picture>
        <a class="homepage-showcase__hotspot" href="${escapeHtml(buttonOneLink)}" data-nav aria-label="${escapeHtml(buttonOneAria)}" style="--desktop-left: 3.083%; --desktop-top: 56.969%; --desktop-width: 12.171%; --desktop-height: 7.729%; --mobile-left: 11.094%; --mobile-top: 38.674%; --mobile-width: 35.308%; --mobile-height: 6.666%;">
          <span>${escapeHtml(buttonOneLabel)}</span>
        </a>
        <a class="homepage-showcase__hotspot" href="${escapeHtml(buttonTwoLink)}" data-nav aria-label="${escapeHtml(buttonTwoAria)}" style="--desktop-left: 16.226%; --desktop-top: 56.969%; --desktop-width: 13.236%; --desktop-height: 7.729%; --mobile-left: 49.992%; --mobile-top: 38.674%; --mobile-width: 38.914%; --mobile-height: 6.666%;">
          <span>${escapeHtml(buttonTwoLabel)}</span>
        </a>
      </div>
    `;
  }

  function renderHomeFeatured(config = {}) {
    const configuredProducts = Array.isArray(config.products) ? config.products.filter((product) => product && product.handle).map(normalizeProduct) : [];
    const automaticCollection = config.collectionHandle ? getCollection(String(config.collectionHandle)) : getCollection('all');
    const liveProducts = automaticCollection?.isLiveCollection ? automaticCollection.products : [];
    const featured = configuredProducts.length ? configuredProducts : (liveProducts.length ? liveProducts.slice(0, 8) : products.slice(0, 8));
    const heading = config.heading || 'Sip summer savings';
    const buttonLabel = config.buttonLabel || 'Save on favs';
    const buttonLink = config.buttonLink || '/collections/save-on-favs';
    return `
      <section class="home-featured-products page-width">
        <h2 class="homepage-showcase__section-label">${escapeHtml(heading)}</h2>
        <div class="home-featured-products__grid" aria-label="${escapeHtml(heading)}">
          ${featured.map(renderProductCard).join('')}
        </div>
        <div class="home-featured-products__cta">
          <a class="button button--ink" href="${escapeHtml(buttonLink)}" data-nav>${escapeHtml(buttonLabel)}</a>
        </div>
      </section>
    `;
  }

  function renderHomeNote(config = {}) {
    const prefix = config.prefix || "Here's the scoop.";
    const text = config.text || "Wellness should feel good and taste good. That's why we offer a range of delicious, convenient products that support your goals while bringing bright, bold flavors to your daily routine.";
    return `<section class="home-note page-width"><p><strong>${escapeHtml(prefix)}</strong> ${escapeHtml(text)}</p></section>`;
  }

  function renderHomeCategories(config = {}) {
    const defaultItems = [
      { visual: 'drinks', title: 'Drinks', link: collectionUrl('drinks') },
      { visual: 'fitness', title: 'Fitness', link: collectionUrl('fitness') },
      { visual: 'snacks', title: 'Snacks', link: collectionUrl('snacks') },
      { visual: 'essentials', title: 'Essentials', link: collectionUrl('essentials') }
    ];
    const items = Array.isArray(config.items) ? config.items : defaultItems;
    const heading = config.heading || 'Empowering your every move';
    const text = config.text || 'Shop snacks, sips, supps, and more!';
    const buttonLabel = config.buttonLabel || 'Shop All Products';
    const buttonLink = config.buttonLink || '/collections/all';
    return `
      <section class="home-categories page-width">
        <h2 class="home-categories__heading">${escapeHtml(heading)}</h2>
        <p class="home-categories__text">${escapeHtml(text)}</p>
        <div class="home-categories__grid">
          ${items.map((item) => {
            const image = item.image || assets[item.visual] || assets.drinks;
            const link = item.link || collectionUrl(item.visual || 'all');
            const title = item.title || '';
            return `<a class="category-card" href="${escapeHtml(link)}" data-nav><div class="category-card__media"><img class="category-card__image" src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy" decoding="async"></div><div class="category-card__label">${escapeHtml(title)}</div></a>`;
          }).join('')}
        </div>
        <div class="home-categories__cta">
          <a class="button button--purple" href="${escapeHtml(buttonLink)}" data-nav>${escapeHtml(buttonLabel)}</a>
        </div>
      </section>
    `;
  }

  function renderHomePromos(config = {}) {
    const defaultItems = [
      { visual: 'bestSellers', title: 'Best Sellers', text: 'Fan-favorite sips, snacks, and supps customers keep coming back for.', buttonLabel: 'Shop Best Sellers', link: '/collections/best-selling' },
      { visual: 'bundles', title: 'Bundles', text: 'Stack your favorites and save with feel-good combos.', buttonLabel: 'Shop Bundles', link: '/collections/bundles' }
    ];
    const items = Array.isArray(config.items) ? config.items : defaultItems;
    return `
      <section class="home-promos page-width">
        <div class="home-promos__grid">
          ${items.map((item) => {
            const image = item.image || assets[item.visual] || assets.bestSellers;
            return `<a class="promo-card" href="${escapeHtml(item.link || '/collections/all')}" data-nav><div class="promo-card__media"><img class="promo-card__image" src="${escapeHtml(image)}" alt="${escapeHtml(item.title || '')}" loading="lazy" decoding="async" width="1077" height="1077"></div><div class="promo-card__overlay"></div><div class="promo-card__content"><h3>${escapeHtml(item.title || '')}</h3><p>${escapeHtml(item.text || '')}</p><span class="button button--purple">${escapeHtml(item.buttonLabel || '')}</span></div></a>`;
          }).join('')}
        </div>
      </section>
    `;
  }

  function renderHome() {
    const configuredModules = readHomeModules();
    const activeModules = configuredModules.length ? configuredModules : [
      { type: 'hero', config: {} },
      { type: 'featured', config: {} },
      { type: 'note', config: {} },
      { type: 'categories', config: {} },
      { type: 'promos', config: {} }
    ];
    const moduleRenderers = {
      hero: renderHomeHero,
      featured: renderHomeFeatured,
      note: renderHomeNote,
      categories: renderHomeCategories,
      promos: renderHomePromos
    };
    return `
      <main id="MainContent">
        <section class="homepage-showcase">
          ${activeModules.map((module) => moduleRenderers[module.type] ? moduleRenderers[module.type](module.config) : '').join('')}
        </section>
      </main>
    `;
  }

  function renderCollectionPage(handle, searchParams) {
    const collection = getCollection(handle);
    if (!collection) return renderNotFound();
    const sortBy = searchParams.get('sort_by') || '';
    const availability = searchParams.get('filter.v.availability') || searchParams.get('availability') || '';
    const minPrice = searchParams.get('filter.v.price.gte') || '';
    const maxPrice = searchParams.get('filter.v.price.lte') || '';
    const minPriceNumber = minPrice === '' ? null : Number(minPrice);
    const maxPriceNumber = maxPrice === '' ? null : Number(maxPrice);
    const highestPrice = collection.products.length ? Math.max(...collection.products.map((product) => product.price)) : 0;
    const filteredProducts = collection.products.filter((product) => {
      const availabilityMatch = !availability
        || (availability === '1' && product.available !== false)
        || (availability === '0' && product.available === false)
        || (availability === 'in-stock' && product.available !== false);
      const priceMatch = (minPriceNumber === null || product.price >= minPriceNumber)
        && (maxPriceNumber === null || product.price <= maxPriceNumber);
      return availabilityMatch && priceMatch;
    });
    const productsList = sortProducts(filteredProducts, sortBy);
    const sortOptions = [
      ['featured', 'Featured'],
      ['best-selling', 'Best selling'],
      ['title-ascending', 'Alphabetical, A-Z'],
      ['price-ascending', 'Price, low to high'],
      ['price-descending', 'Price, high to low']
    ];
    const pagination = collection.pagination && Number(collection.pagination.pages || 0) > 1
      ? `<nav class="pagination" role="navigation" aria-label="Pagination">
          ${collection.pagination.previousUrl ? `<a class="pagination__link" href="${escapeHtml(collection.pagination.previousUrl)}" data-nav>&larr; Previous</a>` : ''}
          <div class="pagination__pages">
            ${(collection.pagination.parts || []).map((part) => part.url
              ? `<a class="pagination__page" href="${escapeHtml(part.url)}" data-nav>${escapeHtml(part.title)}</a>`
              : `<span class="pagination__page${part.current ? ' is-current' : ''}"${part.current ? ' aria-current="page"' : ''}>${escapeHtml(part.title)}</span>`).join('')}
          </div>
          ${collection.pagination.nextUrl ? `<a class="pagination__link" href="${escapeHtml(collection.pagination.nextUrl)}" data-nav>Next &rarr;</a>` : ''}
        </nav>`
      : '';
    return `
      <main id="MainContent" class="page-width collection-page">
        <header class="page-hero collection-hero">
          <p class="page-hero__eyebrow">${escapeHtml(collection.eyebrow)}</p>
          <h1>${escapeHtml(collection.title)}</h1>
          <div class="rte collection-hero__description"><p>${escapeHtml(collection.description)}</p></div>
        </header>
        <div class="collection-toolbar">
          <div class="collection-toolbar__filters">
            <span>Filter:</span>
            <label>
              <span class="visually-hidden">Availability</span>
              <select name="filter.v.availability" aria-label="Availability" data-collection-filter>
                <option value=""${!availability ? ' selected' : ''}>Availability</option>
                <option value="1"${availability === '1' || availability === 'in-stock' ? ' selected' : ''}>In stock</option>
                <option value="0"${availability === '0' ? ' selected' : ''}>Out of stock</option>
              </select>
            </label>
            <details class="collection-toolbar__price">
              <summary>Price</summary>
              <form class="collection-toolbar__price-panel" data-price-filter>
                <div class="collection-toolbar__price-head">
                  <span>The highest price is ${formatMoney(highestPrice)}</span>
                  <button type="button" data-price-reset>Reset</button>
                </div>
                <div class="collection-toolbar__price-fields">
                  <label>
                    <span>$</span>
                    <input type="number" inputmode="decimal" min="0" step="0.01" name="filter.v.price.gte" placeholder="From" value="${escapeHtml(minPrice)}">
                  </label>
                  <label>
                    <span>$</span>
                    <input type="number" inputmode="decimal" min="0" step="0.01" name="filter.v.price.lte" placeholder="To" value="${escapeHtml(maxPrice)}">
                  </label>
                </div>
              </form>
            </details>
          </div>
          <div class="collection-toolbar__right">
            <form class="collection-toolbar__sort" data-collection-sort>
              <label for="SortBy">Sort by:</label>
              <select id="SortBy" name="sort_by">
                ${sortOptions.map(([value, label]) => `<option value="${value}"${sortBy === value || (!sortBy && value === 'featured') ? ' selected' : ''}>${label}</option>`).join('')}
              </select>
            </form>
            <p>${collection.productsCount || productsList.length} products</p>
          </div>
        </div>
        <div class="product-grid">
          ${productsList.map(renderProductCard).join('')}
        </div>
        ${pagination}
      </main>
    `;
  }

  function renderProductPage(handle) {
    const product = findProduct(handle);
    if (!product) return renderNotFound();
    const productConfig = readSectionConfig('main-product') || {};
    const configuredRelated = Array.isArray(productConfig.relatedProducts) ? productConfig.relatedProducts.map(normalizeProduct) : [];
    const related = configuredRelated.length
      ? configuredRelated.slice(0, 4)
      : getCatalogProducts().filter((item) => item.collection === product.collection && item.handle !== product.handle).slice(0, 4);
    const variants = Array.isArray(product.variants) && product.variants.length ? product.variants : [
      { id: `${product.handle}-default`, title: 'Default Title', available: true, price: product.price, compareAt: product.compareAt }
    ];
    product.variants = variants;
    const showVendor = productConfig.showVendor !== false;
    const saleBadge = productConfig.saleBadge || 'Sale';
    const viewingText = productConfig.viewingText || '';
    const lowStockLabel = productConfig.lowStockLabel || 'Low stock:';
    const stockText = Number(product.inventoryQuantity) > 0 ? `Only ${product.inventoryQuantity} left` : (productConfig.stockFallback || '');
    const quantityLabel = productConfig.quantityLabel || 'Quantity';
    const addToCartLabel = productConfig.addToCartLabel || 'Add to cart';
    const buyNowLabel = productConfig.buyNowLabel || 'Buy it now';
    const shareLabel = productConfig.shareLabel || 'Share';
    const relatedHeading = productConfig.relatedHeading || 'Related products';
    return `
      <main id="MainContent" class="page-width product-page">
        <div class="product-page__grid">
          <div class="product-gallery">
            <div class="product-gallery__grid">
              ${product.gallery.map((image) => `
                <figure class="product-gallery__item">
                  <img src="${image}" alt="${escapeHtml(product.title)}" loading="eager" decoding="async">
                </figure>
              `).join('')}
            </div>
          </div>

          <div class="product-summary">
            ${showVendor ? `<p class="product-summary__vendor">${escapeHtml(product.vendor)}</p>` : ''}
            <h1>${escapeHtml(product.title)}</h1>
            <div class="product-summary__price">
              ${product.compareAt > product.price ? `<s>${formatMoney(product.compareAt)} USD</s> <span>${formatMoney(product.price)} USD</span> <span class="product-summary__badge">${escapeHtml(saleBadge)}</span>` : `<span>${formatMoney(product.price)} USD</span>`}
            </div>
            <div class="product-summary__notice">
              ${viewingText ? `<p class="product-summary__viewing">${escapeHtml(viewingText)}</p>` : ''}
              ${stockText ? `<p class="product-summary__stock"><strong>${escapeHtml(lowStockLabel)}</strong> <span></span> ${escapeHtml(stockText)}</p>` : ''}
            </div>
            <form class="product-form" action="/cart/add" method="post" data-product-form data-product-handle="${escapeHtml(product.handle)}">
              ${variants.length > 1 ? `
                <label class="product-form__label" for="ProductVariant">Variant</label>
                <select id="ProductVariant" name="id">
                  ${variants.map((variant) => `<option value="${escapeHtml(variant.id)}"${variant.available === false ? ' disabled' : ''}>${escapeHtml(variant.title)}${variant.available === false ? ' - Sold out' : ''}</option>`).join('')}
                </select>
              ` : `<input type="hidden" name="id" value="${escapeHtml(variants[0].id)}">`}
              <label class="product-form__label" for="ProductQuantity">${escapeHtml(quantityLabel)}</label>
              <div class="product-form__quantity">
                <button type="button" data-qty-minus aria-label="Decrease quantity">-</button>
                <input id="ProductQuantity" type="number" name="quantity" value="1" min="1">
                <button type="button" data-qty-plus aria-label="Increase quantity">+</button>
              </div>
              <button class="button product-form__submit" type="submit"${product.available === false ? ' disabled' : ''}>${escapeHtml(product.available === false ? 'Sold out' : addToCartLabel)}</button>
              <button class="button product-form__buy-now" type="button" name="buy_it_now" data-buy-it-now="single-product" data-buy-it-now-handle="${escapeHtml(product.handle)}" data-buy-it-now-variant="${escapeHtml(variants[0].id)}"${product.available === false ? ' disabled' : ''}>${escapeHtml(buyNowLabel)}</button>
            </form>
            <div class="rte product-summary__description">
              <p>${escapeHtml(product.description)}</p>
            </div>
            <button class="product-summary__share" type="button">${escapeHtml(shareLabel)}</button>
          </div>
        </div>

        ${related.length ? `
          <section class="home-featured-products">
            <h2 class="homepage-showcase__section-label">${escapeHtml(relatedHeading)}</h2>
            <div class="home-featured-products__grid">
              ${related.map(renderProductCard).join('')}
            </div>
          </section>
        ` : ''}
      </main>
    `;
  }

  function renderSearchPage(searchParams) {
    const q = (searchParams.get('q') || '').trim();
    const terms = q.toLowerCase();
    const themeConfig = readSectionConfig('theme-settings');
    const searchConfig = readSectionConfig('main-search') || {};
    const isShopify = themeConfig?.shopify === true;
    const searchProducts = isShopify
      ? (Array.isArray(searchConfig.products) ? searchConfig.products.map(normalizeProduct) : [])
      : (!terms
      ? products.slice(0, 4)
      : products.filter((product) => product.title.toLowerCase().includes(terms) || product.description.toLowerCase().includes(terms)));
    const searchCollections = isShopify ? [] : (!terms
      ? Object.entries(collections)
        .filter(([handle]) => ['all', 'drinks', 'fitness', 'snacks', 'essentials', 'best-selling', 'bundles', 'save-on-favs'].includes(handle))
        .map(([handle, meta]) => ({ handle, ...meta, products: getCollection(handle).products }))
      : Object.entries(collections)
        .filter(([, meta]) => meta.title.toLowerCase().includes(terms) || meta.description.toLowerCase().includes(terms))
        .map(([handle, meta]) => ({ handle, ...meta, products: getCollection(handle).products })));
    const searchArticles = isShopify ? [] : (!terms
      ? articles.slice(0, 2)
      : articles.filter((article) => article.title.toLowerCase().includes(terms) || article.excerpt.toLowerCase().includes(terms)));
    const searchPages = isShopify ? [] : (!terms
      ? Object.entries(pages)
        .filter(([handle]) => ['about', 'contact', 'faq'].includes(handle))
        .map(([handle, page]) => ({ handle, ...page }))
      : Object.entries(pages)
        .filter(([, page]) => page.title.toLowerCase().includes(terms) || page.body.toLowerCase().toLowerCase().includes(terms))
        .map(([handle, page]) => ({ handle, ...page })));
    const resultsCount = isShopify
      ? Number(searchConfig.resultsCount || 0)
      : searchProducts.length + searchCollections.length + searchArticles.length + searchPages.length;
    const searchPerformed = isShopify ? searchConfig.performed === true : Boolean(terms);
    const landingCollections = [
      getCollection('drinks'),
      getCollection('fitness'),
      getCollection('snacks'),
      getCollection('essentials')
    ].filter(Boolean);
    const pagination = isShopify && searchConfig.pagination && Number(searchConfig.pagination.pages || 0) > 1
      ? `<nav class="pagination" role="navigation" aria-label="Pagination">
          ${searchConfig.pagination.previousUrl ? `<a class="pagination__link" href="${escapeHtml(searchConfig.pagination.previousUrl)}" data-nav>&larr; Previous</a>` : ''}
          <div class="pagination__pages">
            ${(searchConfig.pagination.parts || []).map((part) => part.url
              ? `<a class="pagination__page" href="${escapeHtml(part.url)}" data-nav>${escapeHtml(part.title)}</a>`
              : `<span class="pagination__page${part.current ? ' is-current' : ''}"${part.current ? ' aria-current="page"' : ''}>${escapeHtml(part.title)}</span>`).join('')}
          </div>
          ${searchConfig.pagination.nextUrl ? `<a class="pagination__link" href="${escapeHtml(searchConfig.pagination.nextUrl)}" data-nav>Next &rarr;</a>` : ''}
        </nav>`
      : '';
    return `
      <main id="MainContent" class="page-width search-page">
        <header class="page-hero">
          <p class="page-hero__eyebrow">${escapeHtml(searchConfig.eyebrow || 'Search')}</p>
          <h1>${escapeHtml(searchConfig.title || 'Search the store')}</h1>
        </header>
        <form class="search-form" data-search-form action="/search" method="get" role="search">
          <input type="hidden" name="type" value="product">
          <label class="visually-hidden" for="SearchInput">Search</label>
          <input id="SearchInput" type="search" name="q" value="${escapeHtml(q)}" placeholder="Search">
          <button class="button button--purple" type="submit">Search</button>
        </form>
        ${searchPerformed ? `<p class="search-page__count">${resultsCount} results for "${escapeHtml(q)}"</p>` : '<p class="search-page__count">Try a product name.</p>'}
        ${!terms ? `
          <section class="home-categories" style="padding-top:0">
            <h2 class="home-categories__heading" style="font-size:1.5rem">Popular paths</h2>
            <div class="home-categories__grid" style="grid-template-columns:repeat(4,minmax(0,1fr));margin-top:1rem">
              ${landingCollections.map((collection) => `
                <a class="category-card" href="${collectionUrl(collection.handle)}" data-nav>
                  <div class="category-card__media"><img class="category-card__image" src="${collection.image}" alt="${escapeHtml(collection.title)}" loading="lazy" decoding="async"></div>
                  <div class="category-card__label">${escapeHtml(collection.title)}</div>
                </a>
              `).join('')}
            </div>
          </section>
        ` : ''}
        <div class="search-grid">
          ${searchProducts.map(renderProductCard).join('')}
          ${searchCollections.map((collection) => `
            <a class="collection-card" href="${collectionUrl(collection.handle)}" data-nav>
              <div class="collection-card__media"><img src="${collection.image}" alt="${escapeHtml(collection.title)}" loading="lazy" decoding="async"></div>
              <div class="collection-card__content">
                <h3 class="collection-card__title">${escapeHtml(collection.title)}</h3>
                <p class="collection-card__count">${collection.products.length} products</p>
              </div>
            </a>
          `).join('')}
          ${searchArticles.map(renderArticleCard).join('')}
          ${searchPages.map((page) => `
            <a class="search-result-card" href="/pages/${page.handle}" data-nav>
              <div class="search-result-card__content">
                <p class="search-result-card__eyebrow">Page</p>
                <h3>${escapeHtml(page.title)}</h3>
                <p>${escapeHtml(page.body.replace(/<[^>]+>/g, '').slice(0, 120))}</p>
              </div>
            </a>
          `).join('')}
        </div>
        ${pagination}
        ${!terms ? `
          <section class="home-promos" style="padding-top:2rem">
            <div class="home-promos__grid">
              ${searchArticles.map((article) => `
                <a class="promo-card" href="/blogs/news/${article.handle}" data-nav>
                  <div class="promo-card__media"><img class="promo-card__image" src="${article.image}" alt="${escapeHtml(article.title)}" loading="lazy" decoding="async"></div>
                  <div class="promo-card__overlay"></div>
                  <div class="promo-card__content">
                    <h3>${escapeHtml(article.title)}</h3>
                    <p>${escapeHtml(article.excerpt)}</p>
                    <span class="button button--purple">Read article</span>
                  </div>
                </a>
              `).join('')}
            </div>
          </section>
        ` : ''}
      </main>
    `;
  }

  function renderCartPage() {
    const themeConfig = readSectionConfig('theme-settings');
    const cartConfig = readSectionConfig('main-cart') || {};
    const isShopify = themeConfig?.shopify === true;
    const cart = isShopify && Array.isArray(cartConfig.items) ? cartConfig.items : getCart();
    const lines = cart.map((item) => {
      const product = isShopify ? {
        handle: item.handle,
        title: item.title,
        image: item.image,
        url: item.url
      } : findProduct(item.handle);
      if (!product) return '';
      const linePrice = isShopify ? Number(item.linePrice || 0) : product.price * item.quantity;
      const itemUrl = isShopify ? (item.url || productUrl(product)) : productUrl(product);
      const quantityAttributes = isShopify
        ? `name="updates[${escapeHtml(item.key)}]"`
        : 'data-cart-qty';
      return `
        <article class="cart-item" data-cart-item="${escapeHtml(item.handle)}" data-variant="${escapeHtml(item.variantId)}">
          <a class="cart-item__media" href="${escapeHtml(itemUrl)}" data-nav>
            <img src="${product.image}" alt="${escapeHtml(product.title)}" loading="lazy" decoding="async">
          </a>
          <div class="cart-item__content">
            <h2 class="cart-item__title"><a href="${escapeHtml(itemUrl)}" data-nav>${escapeHtml(product.title)}</a></h2>
            <p class="cart-item__variant">${escapeHtml(item.variantTitle || 'Default')}</p>
            <p class="cart-item__price">${formatMoney(linePrice)}</p>
            <label class="cart-item__quantity" for="Quantity-${escapeHtml(item.handle)}">
              Quantity
              <input id="Quantity-${escapeHtml(item.handle)}" type="number" min="0" value="${item.quantity}" ${quantityAttributes}>
            </label>
            ${isShopify ? `<a class="cart-item__remove" href="/cart/change?id=${encodeURIComponent(item.key)}&quantity=0">Remove</a>` : `<button class="cart-item__remove" type="button" data-cart-remove>Remove</button>`}
          </div>
        </article>
      `;
    }).join('');
    const subtotal = isShopify ? Number(cartConfig.totalPrice || 0) : cart.reduce((sum, item) => {
      const product = findProduct(item.handle);
      return sum + (product ? product.price * item.quantity : 0);
    }, 0);
    return `
      <main id="MainContent" class="page-width cart-page">
        <header class="page-hero cart-page__hero">
          <p class="page-hero__eyebrow">${escapeHtml(cartConfig.eyebrow || 'Cart')}</p>
          <h1>${escapeHtml(cartConfig.title || 'Shopping cart')}</h1>
        </header>
        ${cart.length ? `
          <form class="cart-form"${isShopify ? ' action="/cart" method="post"' : ' data-cart-form'}>
            <div class="cart-layout">
              <div class="cart-items">
                ${lines}
              </div>
              <aside class="cart-summary">
                <div class="cart-summary__row">
                  <span>Subtotal</span>
                  <strong>${formatMoney(subtotal)}</strong>
                </div>
                <div class="cart-summary__actions">
                  <button class="button button--purple" type="submit" name="update">Update cart</button>
                  ${isShopify ? '<button class="button button--teal" type="submit" name="checkout">Checkout</button>' : '<button class="button button--teal" type="button" data-checkout-btn>Checkout</button>'}
                </div>
              </aside>
            </div>
          </form>
        ` : `
          <div class="empty-state empty-state--page">
            <h2>Your cart is empty.</h2>
            <p>Keep shopping and add a few favorites.</p>
            <a class="button button--teal" href="/collections/all" data-nav>Shop products</a>
          </div>
        `}
      </main>
    `;
  }

  function renderCheckoutPage() {
    const cart = getCart();
    return `
      <main id="MainContent" class="page-width page-content">
        <article class="page-content__article">
          <header class="page-hero">
            <p class="page-hero__eyebrow">Checkout</p>
            <h1>Secure checkout preview</h1>
          </header>
          <div class="rte page-content__body">
            <p>This is a local preview of the checkout flow. ${cart.length ? `You have ${cartCount()} items ready.` : 'Add a product to the cart first.'}</p>
            <p>The original store would continue to Shopify checkout here.</p>
          </div>
        </article>
      </main>
    `;
  }

  function renderPage(handle) {
    const page = getPage(handle);
    if (!page) return renderNotFound();
    return `
      <main id="MainContent" class="page-width page-content">
        <article class="page-content__article">
          <header class="page-hero">
            <p class="page-hero__eyebrow">${escapeHtml(page.eyebrow)}</p>
            <h1>${escapeHtml(page.title)}</h1>
          </header>
          <div class="rte page-content__body">
            ${page.body}
          </div>
        </article>
      </main>
    `;
  }

  function renderShopifyContent() {
    const shell = document.querySelector('.theme-editor-shell');
    if (!shell) return '';

    const policy = shell.querySelector('.shopify-policy__container');
    if (policy) {
      return `<main id="MainContent" class="page-width page-content"><article class="page-content__article">${policy.outerHTML}</article></main>`;
    }

    const main = shell.querySelector('main');
    return main ? main.outerHTML : '';
  }

  function renderBlogIndex() {
    return `
      <main id="MainContent" class="page-width blog-page">
        <header class="page-hero">
          <p class="page-hero__eyebrow">Journal</p>
          <h1>Stories</h1>
          <div class="rte blog-page__description"><p>News, bundle tips, and product ideas that mirror the original storefront's blog flow.</p></div>
        </header>
        <div class="article-grid">
          ${articles.map(renderArticleCard).join('')}
        </div>
      </main>
    `;
  }

  function renderArticle(handle) {
    const article = getArticle(handle);
    if (!article) return renderNotFound();
    return `
      <main id="MainContent" class="page-width article-page">
        <article class="article-page__article">
          <header class="page-hero">
            <p class="page-hero__eyebrow">Article</p>
            <h1>${escapeHtml(article.title)}</h1>
            <p class="article-page__meta">${new Date(article.publishedAt).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: '2-digit' })}</p>
          </header>
          <div class="article-page__media">
            <img src="${article.image}" alt="${escapeHtml(article.title)}" loading="eager" decoding="async">
          </div>
          <div class="rte article-page__content">
            ${article.content}
          </div>
        </article>
      </main>
    `;
  }

  function renderAccountPage() {
    return `
      <main id="MainContent" class="page-width password-page">
        <header class="page-hero">
          <p class="page-hero__eyebrow">Account</p>
          <h1>Log in</h1>
          <p class="page-hero__text">A lightweight account preview so the header link does not dead-end.</p>
        </header>
        <form class="password-page__form" data-account-form>
          <input type="email" placeholder="Email">
          <input type="password" placeholder="Password">
          <button class="button button--purple" type="submit">Sign in</button>
        </form>
      </main>
    `;
  }

  function renderNotFound() {
    return `
      <main id="MainContent" class="page-width page-content">
        <article class="page-content__article">
          <header class="page-hero">
            <p class="page-hero__eyebrow">404</p>
            <h1>Page not found</h1>
          </header>
          <div class="rte page-content__body">
            <p>That route does not exist in this preview. Try the home page, a collection, or a product.</p>
          </div>
        </article>
      </main>
    `;
  }

  function render() {
    const { path, segments, url } = routeInfo();
    let main = '';
    let bodyClass = 'template-index no-js';

    if (path === '/' || path === '') {
      main = renderHome();
      bodyClass = 'template-index no-js';
    } else if (segments[0] === 'collections' && segments[1]) {
      main = renderCollectionPage(segments[1], url.searchParams);
      bodyClass = 'template-collection no-js';
    } else if (segments[0] === 'products' && segments[1]) {
      main = renderProductPage(segments[1]);
      bodyClass = 'template-product no-js';
    } else if (path === '/search') {
      main = renderSearchPage(url.searchParams);
      bodyClass = 'template-search no-js';
    } else if (path === '/cart') {
      main = renderCartPage();
      bodyClass = 'template-cart no-js';
    } else if (path === '/checkout') {
      main = renderCheckoutPage();
      bodyClass = 'template-page no-js';
    } else if (segments[0] === 'policies' && segments[1]) {
      main = renderShopifyContent() || renderPage(segments[1]);
      bodyClass = 'template-policy no-js';
    } else if (segments[0] === 'pages' && segments[1]) {
      const themeConfig = readSectionConfig('theme-settings');
      main = themeConfig?.shopify === true ? (renderShopifyContent() || renderPage(segments[1])) : renderPage(segments[1]);
      bodyClass = 'template-page no-js';
    } else if (segments[0] === 'blogs' && segments[1] === 'news' && segments[2]) {
      main = renderArticle(segments[2]);
      bodyClass = 'template-article no-js';
    } else if (segments[0] === 'blogs' && segments[1] === 'news') {
      main = renderBlogIndex();
      bodyClass = 'template-blog no-js';
    } else if (path === '/account') {
      main = renderAccountPage();
      bodyClass = 'template-page no-js';
    } else {
      // Shopify may load the theme editor on a synthetic preview path. Keep
      // the storefront useful there by showing the same home preview instead
      // of replacing it with a dead-end 404 screen.
      main = renderHome();
      bodyClass = 'template-index no-js';
    }

    document.body.className = bodyClass;
    app.innerHTML = `<div class="preview-shell">${renderHeader(path)}${main}${renderFooter()}</div>`;
    updateCartBadge();
    const themeConfig = readSectionConfig('theme-settings');
    const siteName = themeConfig?.brandName || 'TrendVibe Merch LLC';
    const pageHeading = app.querySelector('#MainContent h1')?.textContent?.trim() || '';
    document.title = pageHeading ? `${pageHeading} | ${siteName}` : siteName;
  }

  document.addEventListener('click', (event) => {
    const menuToggle = event.target.closest('[data-mobile-menu-toggle]');
    if (menuToggle) {
      const menu = document.getElementById('MobileMenu');
      if (menu) {
        const willOpen = menu.hasAttribute('hidden');
        menu.toggleAttribute('hidden');
        menuToggle.setAttribute('aria-expanded', String(willOpen));
      }
      return;
    }

    const checkoutBtn = event.target.closest('[data-checkout-btn]');
    if (checkoutBtn) {
      event.preventDefault();
      navigate('/checkout');
      return;
    }

    const qtyButton = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (qtyButton) {
      const quantity = qtyButton.closest('.product-form__quantity')?.querySelector('input[name="quantity"]');
      if (quantity) {
        const current = Math.max(1, Number(quantity.value || 1));
        quantity.value = String(qtyButton.matches('[data-qty-plus]') ? current + 1 : Math.max(1, current - 1));
      }
      return;
    }

    const priceReset = event.target.closest('[data-price-reset]');
    if (priceReset) {
      const params = new URLSearchParams(location.search);
      params.delete('filter.v.price.gte');
      params.delete('filter.v.price.lte');
      const query = params.toString();
      navigate(`${location.pathname}${query ? `?${query}` : ''}`);
      return;
    }


    const cartRemove = event.target.closest('[data-cart-remove]');
    if (cartRemove) {
      const row = cartRemove.closest('[data-cart-item]');
      if (!row) return;
      const handle = row.getAttribute('data-cart-item');
      const variantId = row.getAttribute('data-variant');
      setCart(getCart().filter((item) => item.handle !== handle || item.variantId !== variantId));
      render();
      return;
    }

    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    if (href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:') || href === '#') return;
    if (anchor.target && anchor.target !== '_self') return;
    const next = new URL(href, location.origin);
    if (next.origin !== location.origin) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    navigate(`${next.pathname}${next.search}${next.hash}`);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('[data-search-form]')) {
      event.preventDefault();
      const data = new FormData(form);
      navigate(`/search${toQueryString({ q: data.get('q')?.toString() || '', type: data.get('type')?.toString() || 'product' })}`);
      return;
    }

    if (form.matches('[data-product-form]')) {
      const themeConfig = readSectionConfig('theme-settings');
      if (themeConfig?.shopify === true) return;
      event.preventDefault();
      const handle = form.getAttribute('data-product-handle');
      const product = handle ? findProduct(handle) : null;
      if (!product) return;
      const data = new FormData(form);
      const variantId = data.get('id')?.toString() || `${handle}-default`;
      const quantity = Math.max(1, Number(data.get('quantity') || 1));
      const variant = (product.variants || []).find((item) => item.id === variantId) || { id: variantId, title: 'Default Title' };
      const cart = getCart();
      const existing = cart.find((item) => item.handle === handle && item.variantId === variant.id);
      if (existing) {
        existing.quantity += quantity;
      } else {
        cart.push({
          handle,
          variantId: variant.id,
          variantTitle: variant.title,
          quantity
        });
      }
      setCart(cart);
      navigate('/cart');
      return;
    }

    if (form.matches('[data-price-filter]')) {
      event.preventDefault();
      const data = new FormData(form);
      const params = new URLSearchParams(location.search);
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach((name) => {
        const value = data.get(name)?.toString().trim() || '';
        if (value) {
          params.set(name, value);
        } else {
          params.delete(name);
        }
      });
      const query = params.toString();
      navigate(`${location.pathname}${query ? `?${query}` : ''}`);
      return;
    }

    if (form.matches('[data-cart-form]')) {
      event.preventDefault();
      const inputs = Array.from(form.querySelectorAll('[data-cart-qty]'));
      const cart = getCart();
      inputs.forEach((input) => {
        const row = input.closest('[data-cart-item]');
        if (!row) return;
        const handle = row.getAttribute('data-cart-item');
        const variantId = row.getAttribute('data-variant');
        const item = cart.find((entry) => entry.handle === handle && entry.variantId === variantId);
        if (!item) return;
        item.quantity = Math.max(0, Number(input.value || 0));
      });
      setCart(cart.filter((item) => item.quantity > 0));
      render();
      return;
    }

    if (form.matches('[data-account-form]')) {
      event.preventDefault();
      navigate('/');
      return;
    }
  });

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && (select.closest('[data-collection-sort]') || select.matches('[data-collection-filter]'))) {
      const params = new URLSearchParams(location.search);
      if (select.name === 'sort_by') {
        params.set('sort_by', select.value);
      } else if (select.value) {
        params.set(select.name, select.value);
      } else {
        params.delete(select.name);
      }
      const query = params.toString();
      navigate(`${location.pathname}${query ? `?${query}` : ''}`);
    }
  });

  document.addEventListener('focusout', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.closest('[data-price-filter]')) {
      input.form?.requestSubmit();
    }
  });

  document.addEventListener('input', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.matches('[data-cart-qty]')) {
      const row = input.closest('[data-cart-item]');
      if (!row) return;
      const handle = row.getAttribute('data-cart-item');
      const variantId = row.getAttribute('data-variant');
      const cart = getCart();
      const item = cart.find((entry) => entry.handle === handle && entry.variantId === variantId);
      if (!item) return;
      item.quantity = Math.max(0, Number(input.value || 0));
      setCart(cart.filter((entry) => entry.quantity > 0));
      updateCartBadge();
    }
  });

  window.addEventListener('popstate', render);
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('shopify:section:unload', render);
  document.addEventListener('shopify:section:reorder', render);
  render();
})();
